import { tw } from 'twind';

export default function Testimonial({ quote = '' }) {
  return (
    <blockquote className={tw`mx-auto w-full max-w-2xl text-center px-10`}>
      <p className={tw`text-xs text-black font-light p-2`}>{`"${quote}"`}</p>
    </blockquote>
  );
}
